var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "order_box",
      attrs: {
        "close-on-click-modal": false,
        visible: _vm.modals,
        title: "发送货",
        "before-close": _vm.handleClose,
        width: "900px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.modals = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "formItem",
          attrs: {
            model: _vm.formItem,
            "label-width": "130px",
            rules: _vm.rules,
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "选择类型：" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: _vm.isEdit, required: "" },
                  on: {
                    change: function ($event) {
                      return _vm.changeRadioType(_vm.formItem.deliveryType)
                    },
                  },
                  model: {
                    value: _vm.formItem.deliveryType,
                    callback: function ($$v) {
                      _vm.$set(_vm.formItem, "deliveryType", $$v)
                    },
                    expression: "formItem.deliveryType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "express" } }, [
                    _vm._v("发货"),
                  ]),
                  _c("el-radio", { attrs: { label: "send" } }, [
                    _vm._v("送货"),
                  ]),
                  _c("el-radio", { attrs: { label: "fictitious" } }, [
                    _vm._v("虚拟"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.formItem.deliveryType === "express"
            ? _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "发货类型：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.isEdit },
                          on: {
                            change: function ($event) {
                              return _vm.changeRadio(
                                _vm.formItem.expressRecordType
                              )
                            },
                          },
                          model: {
                            value: _vm.formItem.expressRecordType,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "expressRecordType", $$v)
                            },
                            expression: "formItem.expressRecordType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "3" } }, [
                            _vm._v("商家寄件"),
                          ]),
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("手动填写"),
                          ]),
                          _vm.checkPermi(["supplier:order:sheet:info"])
                            ? _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("电子面单打印"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.formItem.expressRecordType === "3"
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "寄件人姓名：",
                              prop: "shipment.sendRealName",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入寄件人姓名" },
                              model: {
                                value: _vm.formItem.shipment.sendRealName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formItem.shipment,
                                    "sendRealName",
                                    $$v
                                  )
                                },
                                expression: "formItem.shipment.sendRealName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "寄件人电话：",
                              prop: "shipment.sendPhone",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入寄件人电话" },
                              model: {
                                value: _vm.formItem.shipment.sendPhone,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formItem.shipment,
                                    "sendPhone",
                                    $$v
                                  )
                                },
                                expression: "formItem.shipment.sendPhone",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "寄件人地址：",
                              prop: "shipment.sendAddress",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入寄件人地址" },
                              model: {
                                value: _vm.formItem.shipment.sendAddress,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formItem.shipment,
                                    "sendAddress",
                                    $$v
                                  )
                                },
                                expression: "formItem.shipment.sendAddress",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "快递公司：",
                              prop: "shipment.kuaidicom",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { "value-key": "id", filterable: "" },
                                on: { change: _vm.onChangeShipmentExpress },
                                model: {
                                  value: _vm.formItem.shipment.kuaidicom,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formItem.shipment,
                                      "kuaidicom",
                                      $$v
                                    )
                                  },
                                  expression: "formItem.shipment.kuaidicom",
                                },
                              },
                              _vm._l(_vm.shipmentExpress, function (item, i) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    value: item.value,
                                    label: item.label,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "快递业务类型：",
                              prop: "shipment.serviceType",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "请选择业务类型",
                                },
                                model: {
                                  value: _vm.formItem.shipment.serviceType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formItem.shipment,
                                      "serviceType",
                                      $$v
                                    )
                                  },
                                  expression: "formItem.shipment.serviceType",
                                },
                              },
                              _vm._l(_vm.serviceTypeList, function (item) {
                                return _c(
                                  "el-option",
                                  { key: item, attrs: { value: item } },
                                  [_vm._v(_vm._s(item))]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "express_temp_id",
                            attrs: {
                              label: "电子面单：",
                              prop: "shipment.tempid",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "acea-row" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    class: [
                                      _vm.formItem.shipment.tempid
                                        ? "width9"
                                        : "width8",
                                    ],
                                    attrs: { placeholder: "请选择电子面单" },
                                    on: { change: _vm.onChangeExpressTempId },
                                    model: {
                                      value: _vm.formItem.shipment.tempid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formItem.shipment,
                                          "tempid",
                                          $$v
                                        )
                                      },
                                      expression: "formItem.shipment.tempid",
                                    },
                                  },
                                  _vm._l(
                                    _vm.expressTempIdList,
                                    function (item, i) {
                                      return _c("el-option", {
                                        key: i,
                                        attrs: {
                                          value: item.temp_id,
                                          label: item.temp_id,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                                _vm.formItem.shipment.tempid
                                  ? _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "tempImgList ml10" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "demo-image__preview",
                                              },
                                              [
                                                _c("el-image", {
                                                  staticStyle: {
                                                    width: "36px",
                                                    height: "36px",
                                                  },
                                                  attrs: {
                                                    src: _vm.expressTempIdImg,
                                                    "preview-src-list": [
                                                      _vm.expressTempIdImg,
                                                    ],
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "取件日期：" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { type: "button" },
                                model: {
                                  value: _vm.formItem.shipment.dayType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formItem.shipment,
                                      "dayType",
                                      $$v
                                    )
                                  },
                                  expression: "formItem.shipment.dayType",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("今天"),
                                ]),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("明天"),
                                ]),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v("后天"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "取件时间：" } },
                          [
                            _c("el-time-picker", {
                              attrs: {
                                "is-range": "",
                                format: "HH:mm",
                                "value-format": "HH:mm",
                                "range-separator": "-",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                                placeholder: "选择时间范围",
                              },
                              on: { change: _vm.onchangeTime },
                              model: {
                                value: _vm.pickupTime,
                                callback: function ($$v) {
                                  _vm.pickupTime = $$v
                                },
                                expression: "pickupTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "快递公司：", prop: "company" },
                            model: {
                              value: _vm.nowCompany,
                              callback: function ($$v) {
                                _vm.nowCompany = $$v
                              },
                              expression: "nowCompany",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { "value-key": "code", filterable: "" },
                                on: { change: _vm.onChangeExport },
                                model: {
                                  value: _vm.formItem.company,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formItem, "company", $$v)
                                  },
                                  expression: "formItem.company",
                                },
                              },
                              _vm._l(_vm.express, function (item, i) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: { value: item, label: item.name },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                  _vm.formItem.expressRecordType === "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: "快递单号：", prop: "expressNumber" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入快递单号" },
                            model: {
                              value: _vm.formItem.expressNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.formItem, "expressNumber", $$v)
                              },
                              expression: "formItem.expressNumber",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formItem.expressRecordType === "2"
                    ? [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "express_temp_id",
                            attrs: {
                              label: "电子面单：",
                              prop: "expressTempId",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "acea-row" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    class: [
                                      _vm.formItem.expressTempId
                                        ? "width9"
                                        : "width8",
                                    ],
                                    attrs: { placeholder: "请选择电子面单" },
                                    on: { change: _vm.onChangeImg },
                                    model: {
                                      value: _vm.formItem.expressTempId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formItem,
                                          "expressTempId",
                                          $$v
                                        )
                                      },
                                      expression: "formItem.expressTempId",
                                    },
                                  },
                                  _vm._l(
                                    _vm.exportTempList,
                                    function (item, i) {
                                      return _c("el-option", {
                                        key: i,
                                        attrs: {
                                          value: item.temp_id,
                                          label: item.title,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                                _vm.formItem.expressTempId
                                  ? _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "tempImgList ml10" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "demo-image__preview",
                                              },
                                              [
                                                _c("el-image", {
                                                  staticStyle: {
                                                    width: "36px",
                                                    height: "36px",
                                                  },
                                                  attrs: {
                                                    src: _vm.tempImg,
                                                    "preview-src-list": [
                                                      _vm.tempImg,
                                                    ],
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "寄件人姓名：", prop: "toName" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入寄件人姓名" },
                              model: {
                                value: _vm.formItem.toName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formItem, "toName", $$v)
                                },
                                expression: "formItem.toName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "寄件人电话：", prop: "toTel" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入寄件人电话" },
                              model: {
                                value: _vm.formItem.toTel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formItem, "toTel", $$v)
                                },
                                expression: "formItem.toTel",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "寄件人地址：", prop: "toAddr" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入寄件人地址" },
                              model: {
                                value: _vm.formItem.toAddr,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formItem, "toAddr", $$v)
                                },
                                expression: "formItem.toAddr",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm.formItem.deliveryType === "send"
            ? _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "送货人姓名：", prop: "deliveryName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入送货人姓名" },
                        model: {
                          value: _vm.formItem.deliveryName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formItem, "deliveryName", $$v)
                          },
                          expression: "formItem.deliveryName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "送货人电话：", prop: "deliveryTel" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入送货人电话" },
                        model: {
                          value: _vm.formItem.deliveryTel,
                          callback: function ($$v) {
                            _vm.$set(_vm.formItem, "deliveryTel", $$v)
                          },
                          expression: "formItem.deliveryTel",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.cancel("formItem")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.putSend("formItem")
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }